import { render, staticRenderFns } from "./TripsView.vue?vue&type=template&id=381b76d9&scoped=true&"
import script from "./TripsView.vue?vue&type=script&lang=js&"
export * from "./TripsView.vue?vue&type=script&lang=js&"
import style0 from "./TripsView.vue?vue&type=style&index=0&id=381b76d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b76d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDialog,VNavigationDrawer,VTooltip})
